import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

export default function HVACReviews() {
    const reviews = [
      {
        name: "Jermiah Bollman",
        title: "Cool IT",
        review: "We've included iFLO on all our new installs and haven't had a call back yet"
      },
      {
        name: "Ryan Czir", 
        title: "McAllister Group",
        review: "The best solution on the market for stopping zooglea"
      },
      {
        name: "Scott Strickland",
        title: "McAllister Group", 
        review: "Ready to share this amazing product with customers and put an end to zooglea!"
      },
      {
        name: "Nathan Adams",
        title: "McAllister Group",
        review: "When we show people the solution, it has been blowing up, it's awesome!"
      },
      {
        name: "Julian Scadden",
        title: "Nexstar Network",
        review: "This technology can directly tie to the operations of your business and really add more value"
      },
      {
        name: "Nathan Adams",
        title: "McAllister Group",
        review: "iFLO Pro helps us work smarter and with more efficiency!"
      },
      {
        name: "",
        title: "A2Z Air Inc.",
        review: "We’ve been using the iFlo Pro safety drain switch for a while now, and it’s been an absolute game-changer."
      },
      {
        name: "",
        title: "True Temp LLC-PSL",
        review: "Our customers are thrilled with the results—no more unexpected shutdowns, no water damage worries, and their AC systems run smoothly year-round."
      },
      
    ];

    // Create schema markup for reviews
    const reviewSchema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "iFLO Pro",
      "description": "Smart automated device that dispenses bio-enzymatic cleaner to prevent biogenic bacteria from clogging drain lines",
      "review": reviews.map(review => ({
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": review.name
        },
        "reviewBody": review.review
      }))
    };

    return (
      <>
        <section className="bg-white text-black mt-20">
      
            {/* Reviews Section */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="w-full text-center relative"
            >
              <h2 className="text-lg uppercase text-gray-600 tracking-widest mb-4">Reviews</h2>
              <h3 className="text-3xl md:text-5xl font-bold">
                WHAT <span className="text-yellow-400">HVAC PROS</span> HAVE SAID
              </h3>

              <div className="md:block hidden absolute inset-y-0 left-0 w-48 md:w-64 lg:w-96 bg-gradient-to-r from-white via-white/90 to-transparent pointer-events-none z-10"></div>
                  <div className="md:block hidden absolute inset-y-0 right-0 w-48 md:w-64 lg:w-96 bg-gradient-to-l from-white via-white/90 to-transparent pointer-events-none z-10"></div>


              {/* Review Carousel */}
              <div className="relative mt-10 px-4 md:px-10 max-w-full mx-auto">
                <Splide
                  options={{
                    type: 'loop',
                    perPage: 6,
                    perMove: 1,
                    gap: '1rem',
                    pagination: false,
                    arrows: false,
                    autoplay: true,
                    breakpoints: {
                      768: { perPage: 1 },
                    },
                  }}
                >
                  {/* Gradient Overlays */}
                  {[...reviews, ...reviews].map((review, index) => (
                    <SplideSlide key={index}>
                      <motion.div 
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        className="border border-black p-8 rounded-lg text-left bg-white shadow-lg relative max-w-4xl mx-auto"
                      >
                        <p className="text-yellow-400 font-bold text-xl">{review.name}</p>
                        <p className="text-black text-lg">{review.title}</p>
                        <p className="text-black mt-4 italic text-xl">"{review.review}"</p>
                      </motion.div>
                    </SplideSlide>
                  ))}
                </Splide>
              </div>
            </motion.div>
  
            {/* Sales Conversion Section */}
            <motion.div 
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="max-w-5xl mx-auto mt-20 flex flex-col md:flex-row items-center gap-10"
            >
              <div className="flex-1 md:p-6 p-6">
                <h3 className="text-3xl md:text-4xl font-bold">TOOLS FOR ON THE FIELD</h3>
                <p className="text-black text-xl mt-4">
                  iFLO Pro offers high-quality video books to help teach homeowners about the benefits of iFLO Pro.
                  Make certain everyone gets the same information out on the field at no extra charge.
                </p>
                <a href="/request-materials" className="text-black bg-yellow-400 px-4 py-2 rounded-lg text-lg font-semibold mt-4 inline-block hover:text-yellow-500 transition-colors">
                  Contact us to get yours »
                </a>
              </div>
              <motion.div 
                className="flex-1"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <img 
                  src="https://cdn.shopify.com/s/files/1/0768/7353/1706/files/Pro_Video_Book_Open_GIF.gif?v=1734968444" 
                  alt="Sales Conversion Media" 
                />
              </motion.div>
            </motion.div>
  
            {/* CTA Section */}
            <motion.div 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative mt-20 bg-gray-50"
            >
              <video 
                 src="https://cdn.shopify.com/videos/c/o/v/46003eb8d9d44290bb94b12d7e2c1a75.mp4" 
                alt="Control Image" 
                autoPlay
                loop
                muted
                onContextMenu={(e) => e.preventDefault()}
                className="w-full h-[700px] object-cover opacity-90"
              />
              <motion.div 
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
                className="absolute inset-0 flex flex-col items-center justify-center text-center"
              >
                <div className="mx-auto max-w-[90%] bg-gray-50/30 p-8 border border-gray rounded-2xl">
                <h3 className="text-3xl md:text-5xl font-bold text-black">LET'S CONTROL THE CONTROLLABLES.</h3>
                <p className="text-black text-3xl mt-4 mb-10">
                  Become a Certified iFLO Pro installer.
                </p>
                <motion.a 
                  href="/signup" 
                  className="mt-4 bg-yellow-400 text-black px-6 py-3 rounded-lg font-bold hover:bg-yellow-500 transition-colors"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  SIGN UP
                </motion.a>
                </div>
              </motion.div>
            </motion.div>
      </section>
      </>
    );
}